function resolveTicketByTicketType(tickets, type, category) {
    return tickets.find(t => t.type === type && t.category === category);
}

function getParentTicket(tickets, child) {
    return tickets.find(t => !t.locked
        && t.type !== child.type
        && t.category === child.category,
    );
}

function getChildTicket(tickets, category, type) {
    return tickets.find(t => t.locked
        && t.type === type
        && t.category === category,
    );
}

function getTicketByCategoryAndType(tickets, category, type) {
    return tickets.find(t => t.category === category && t.type === type);
}

function getNumberOfTicketsById(tickets, id) {
    return tickets.filter(t => t.id === id).length;
}

function getTicketTypes(tickets) {
    return tickets.reduce(
        (types, ticket) => {
            if (types.indexOf(ticket.type) === -1) {
                return [...types, ticket.type];
            }

            return types;
        },
        [],
    );
}

export {
    resolveTicketByTicketType,
    getParentTicket,
    getChildTicket,
    getTicketByCategoryAndType,
    getNumberOfTicketsById,
    getTicketTypes,
};
